import React from 'react';
import Grid from '@material-ui/core/Grid';
import OrderCard from '../OrderCard';
import { ActivateClickHandler, TransferClickHandler } from '../../OrdersPage';
import { Order } from 'types/schema-generated-types';

interface OrdersListProps {
  orders: Order[];
  onActivateMastercodeClick: ActivateClickHandler;
  onTransferMastercodeClick: TransferClickHandler;
}

const OrdersList: React.SFC<OrdersListProps> = ({
  orders,
  onActivateMastercodeClick,
  onTransferMastercodeClick
}) => (
  <Grid container direction="column" spacing={3}>
    {orders.map(order => (
      <Grid item key={`order-${order.id}`}>
        <OrderCard
          order={order}
          onActivateMastercodeClick={onActivateMastercodeClick}
          onTransferMastercodeClick={onTransferMastercodeClick}
        />
      </Grid>
    ))}
  </Grid>
);

export default OrdersList;
